import { createSelector } from 'reselect';

export const getSurveys = (state) => state.surveys;

export const getActiveSurvey = createSelector(getSurveys, (surveys) =>
    surveys.find(({ active }) => active)
);
